import { useMemo } from 'react';
import RxGoogleMap from '../map/RxGoogleMap';
import { useContext } from './context';

const layers = [
  { id: 'lime-rx', name: 'Lime Rx' },
  { id: 'phosphorus-rx', name: 'Phosphorus Rx' },
  { id: 'potassium-rx', name: 'Potassium Rx' },
];

export default function LpkMap() {
  const { focusedInstanceId, tab, year } = useContext();

  const filters = useMemo(
    () => ({
      ...(focusedInstanceId ? { prescriptionId: focusedInstanceId } : null),
      cropYear: year,
    }),
    [focusedInstanceId, year],
  );

  const layerVisibilities = useMemo(
    () => ({
      'lime-rx': /(Instances|L)/i.test(tab),
      'phosphorus-rx': /(Instances|P)/i.test(tab),
      'potassium-rx': /(Instances|K)/i.test(tab),
    }),
    [tab],
  );

  return (
    <RxGoogleMap
      pkRemovalEnabled
      layers={layers}
      layerVisibilities={layerVisibilities}
      filters={filters}
    />
  );
}
